'use client';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import * as _ from 'underscore';

import * as tx from '../../../../../constants/strings';

import { 
  checkoutGetSelectedShippingMethods, 
  getCartGrandTotal,  
  getCheckoutStepData,
} from '../../../../../utils/checkout';
import { getStoreLanguage } from '../../../../../utils/language';

import LoadingIcon from '../../../../Icons/LoadingIcon';
import Radio from '../../../../Input/Radio';
import StaticImage from '../../../../Image/StaticImage';

import * as cartActionCreators from '../../../../../actions/cart';
import * as checkoutActionCreators from '../../../../../actions/checkout';
import * as userActionCreators from '../../../../../actions/user';
let allActionCreators = Object.assign({}, cartActionCreators, checkoutActionCreators, userActionCreators);

export class CheckoutStepBuylistPaymentMethodInput extends Component {

  constructor(props) {
    super(props);

    let currentPaymentMethod = null;
    const stepData = getCheckoutStepData(this.props.config, this.props.checkout.stepData);

    if(stepData && stepData.data && stepData.data.paymentMethod) {
      currentPaymentMethod = stepData.data.paymentMethod;
    }

    this.state = {
      
      selectedMethod: currentPaymentMethod, 

      paymentMethods: null,
      paymentMethodsLoading: true,
    };

    this.controller = null;
  }

  componentDidMount() {
    this.fetchPaymentMethods();
    this.fetchMe();
  }

  componentDidUpdate(prevProps, prevState) {

    const prevMethods = checkoutGetSelectedShippingMethods(prevProps.checkout.stepData);
    const currentMethods = checkoutGetSelectedShippingMethods(this.props.checkout.stepData);

    const prevMethodUuids = prevMethods?.filter((m) => m.shippingMethod.publicUuid !== null)
                .map((mtd) => mtd.shippingMethod.publicUuid).sort();
    const currentMethodUuids = currentMethods?.filter((m) => m.shippingMethod.publicUuid !== null)
                .map((mtd) => mtd.shippingMethod.publicUuid).sort();

    if(!_.isEqual(prevMethodUuids, currentMethodUuids)) {
      const visibleMethods = [ ...this.getApplicablePaymentMethods(), ...this.getConditionalPaymentMethods() ];

      let foundMethod = false;
      for(const pm of visibleMethods) {
        if(this.state.selectedMethod && this.state.selectedMethod.publicUuid === pm.publicUuid) {
          foundMethod = true;
        }
      }

      if(this.state.selectedMethod !== null && !foundMethod) {
        this.setState({ selectedMethod: null }, () => {
          this.props.setStepData(this.props.config, {
            paymentMethod: null, 
          });
        });
      }
    }
  }

  componentWillUnmount() {
    if(this.controller) {
      this.controller.abort();
    }
  }

  getLanguage() {
    const { i18n } = this.props;
    return getStoreLanguage(i18n);
  }

  async fetchMe() {

    if(this.controller) {
      this.controller.abort();
    }
    const controller = new AbortController();
    this.controller = controller;

    await this.props.usersFetchMe(controller.signal)
      .catch((errResp) => {
        if(controller.signal.aborted) { return null; }
        if(errResp) { console.error(errResp); }
      });
  }

  fetchPaymentMethods() {

    this.setState({
      paymentMethods: null,
      paymentMethodsLoading: true,
    });

    if(!this.state.paymentMethods) {     
      this.props.checkoutFetchBuylistPaymentMethods()
      .then((resp) => {

        this.setState({
          paymentMethods: resp,
          paymentMethodsLoading: false,
        }, () => {
          
          let validatedSelectedMethod = null;
          const applicableMethods = this.getApplicablePaymentMethods();

          if(this.state.selectedMethod && this.state.selectedMethod.public_uuid && applicableMethods) {

            for(const payMethod of applicableMethods) {
              if(payMethod.public_uuid && payMethod.public_uuid === this.state.selectedMethod.public_uuid) {
                validatedSelectedMethod = this.state.selectedMethod;
                break;
              }
            }
            if(validatedSelectedMethod === null) {
              this.props.setStepData(this.props.config, {
                paymentMethod: null, 
              });
              this.setState({
                selectedMethod: null, 
              });
            }
          }
        });
      })
      .catch((errResp) => {
        if(errResp) { console.error(errResp); }
        this.setState({ paymentMethodsLoading: false, });
      });
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    if(this.state.selectedMethod && this.state.selectedMethod) {
      this.props.setStepData(this.props.config, {
        paymentMethod: this.state.selectedMethod, 
      });
    }
  }

  setPaymentMethod(evt) {
    const methodUuid = evt.target.value;
    if(!methodUuid || !this.state.paymentMethods || !this.state.paymentMethods.length) { return null; }

    for(const payMethod of this.state.paymentMethods) {
      if(payMethod.public_uuid === methodUuid) {
        this.setState({ selectedMethod: payMethod }, () => {
          this.props.setStepData(this.props.config, {
            paymentMethod: payMethod,
          });
          this.props.setStoreCreditPricing(payMethod.isStoreCredit === true);
        });
        return null;
      }
    }
  }

  toggleApplyStoreCredit(evt) {
    this.setState({ applyStoreCredit: !this.state.applyStoreCredit }, () => {

      const cartTotal = getCartGrandTotal(this.props.cart.currentCart, this.props.checkout.stepData);
      const noPaymentRequired = this.state.applyStoreCredit && cartTotal <= this.props.user.user.storeCredit.balance;

      const stepData = {
        applyStoreCredit: this.state.applyStoreCredit, 
      };

      if(this.state.applyStoreCredit) {

        stepData['availableStoreCredit'] = noPaymentRequired ? cartTotal : this.props.user.user.storeCredit.balance;
        stepData['noPaymentRequired'] = noPaymentRequired;

        if(noPaymentRequired) {
          stepData['paymentMethod'] = null;

          this.setState({ selectedMethod: null });
        }

      } else {
        stepData['availableStoreCredit'] = 0;
        stepData['noPaymentRequired'] = false;
      }

      this.props.setStepData(this.props.config, stepData);
    });
  }

  hasPaymentMethods() {
    if(!this.state.paymentMethods || !this.state.paymentMethods.length) { return false; }
    return this.getConditionalPaymentMethods().length > 0 || this.getApplicablePaymentMethods().length > 0;
  }

  getApplicablePaymentMethods() {
    if(!this.state.paymentMethods || !this.state.paymentMethods.length) { return []; }

    const respMethods = [];
    for(const pm of this.state.paymentMethods) {
      if(pm.conditionalDisplay === false) {
        respMethods.push(pm);
      }
    }
    return respMethods;
  }

  getConditionalPaymentMethods() {
    if(!this.state.paymentMethods || !this.state.paymentMethods.length) { return []; }

    const respMethods = [];
    const shippingMethods = checkoutGetSelectedShippingMethods(this.props.checkout.stepData);

    for(const pm of this.state.paymentMethods) {
      if(pm.conditionalDisplay && shippingMethods.length === 1) {
        if(shippingMethods[0] && shippingMethods[0].shippingMethod.allowPaymentAtPickup === true && pm.allowPaymentAtPickup) {
          respMethods.push(pm);
        }
      }
    }
    return respMethods;
  }

  isOptionSelected(option) {
    if(!option || !option.public_uuid) { return false; }
    if(!this.state.selectedMethod || !this.state.selectedMethod.public_uuid) { return false; }
    return this.state.selectedMethod.public_uuid === option.public_uuid ? true : false;
  }

  render() {

    const {t} = this.props;

    return <div className={'CheckoutStepBuylistPaymentMethodInput CheckoutStepComponent'}>
      <div className='cspmLiner'>
        <form className={'checkoutStepRadioForm'} onSubmit={this.handleSubmit.bind(this)}>
          <div className='checkoutFormSubheader'>{t(tx.TX_CHECKOUT_PAYMENT_METHOD)}</div>
          {this.state.paymentMethodsLoading ?
            <div className='checkoutRadioLoadingWrapper'>
              <LoadingIcon iconClass='iconElement' />
            </div> :
            <>
              {this.state.applyStoreCredit && getCartGrandTotal(this.props.cart.currentCart, this.props.checkout.stepData) <= this.props.user.user.storeCredit.balance ?
                <></> :
                <>
                  {this.hasPaymentMethods() ?
                    <div className='radioOptionsWrapper'>
                      
                      {this.getConditionalPaymentMethods().map((opt, j) => {
                        return <div key={j} className={this.isOptionSelected(opt) ? 'radioOptionElementWrapper selected' : 'radioOptionElementWrapper'}>
                          <div className='radioInputWrapper'>
                            <Radio
                              id={`paymentMethod-cond-${j}`}
                              className='pmInput'
                              name='payment-method'
                              adminTheme={false}
                              disabled={false}
                              value={opt.public_uuid}
                              checked={this.isOptionSelected(opt)}
                              onChange={this.setPaymentMethod.bind(this)} />
                          </div>
                          <label htmlFor={`paymentMethod-cond-${j}`}>
                            <div className='radioLabelWrapper'>
                              <div className='radioTitle'>{t(opt.name)}</div>
                              <div className='radioSubtitle'>{opt.description}</div>
                            </div>
                          </label>
                        </div>;
                      })}

                      {this.getApplicablePaymentMethods().map((opt, i) => {
                        return <div key={i} className={this.isOptionSelected(opt) ? 'radioOptionElementWrapper selected' : 'radioOptionElementWrapper'}>
                          <div className='radioInputWrapper'>
                            <Radio
                              id={`paymentMethod-${i}`}
                              className='pmInput'
                              name='payment-method'
                              adminTheme={false}
                              disabled={false}
                              value={opt.public_uuid}
                              checked={this.isOptionSelected(opt)}
                              onChange={this.setPaymentMethod.bind(this)} />
                          </div>
                          <label htmlFor={`paymentMethod-${i}`}>
                            {opt.schema && opt.schema.displayLogo ?
                              <div className='radioLabelWrapper'>
                                <div className='radioTitle imgTitle'>
                                  <div className='imgTitleWrapper'>
                                    <StaticImage 
                                      imgObj={{
                                        src: opt.schema.displayLogo, 
                                        alt: opt.getDisplayName(t), 
                                        noTranslate: true,
                                      }} />
                                  </div>
                                  {!opt.schema.hideLabel ?
                                    <div className='imgTitleLabel'>{opt.getDisplayName(t)}</div> :
                                    null
                                  }
                                </div>
                                <div className='radioSubtitle'>{opt.description}</div>
                              </div> :
                              <div className='radioLabelWrapper'>
                                <div className='radioTitle'>{opt.getDisplayName(t)}</div>
                                <div className='radioSubtitle'>{opt.description}</div>
                              </div>
                            }
                          </label>
                        </div>;
                      })}
                    </div> :
                    <div className='radioNoOptions'>{t(tx.TX_CHECKOUT_NO_PAYMENT_METHODS)}</div>
                  }
                </>
              }
            </>
          }
        </form>
      </div>
    </div>;
  }
}

function mapStateToProps(state) {
  return {
    cart: state.cart, 
    checkout: state.checkout,
    user: state.user,
  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(CheckoutStepBuylistPaymentMethodInput));